import { render, staticRenderFns } from "./ViewComponent.vue?vue&type=template&id=34c09e52&"
import script from "./ViewComponent.vue?vue&type=script&lang=js&"
export * from "./ViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewComponent.vue"
export default component.exports